import React from 'react'
import cucarachita from '../images/cucarachita.jpg'
import reparacion from '../images/reparacion.jpg'
import mercedes from '../images/mercedes.jpg'

const Slider = () => {
    return(
        <>
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                <ol className="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img className="d-block w-100" src={cucarachita} alt="First slide"/>
                        <div className="carousel-caption d-none d-md-block">
                            <h5>Confianza en nuestros productos</h5>
                            <p>Te acompañamos a dondequiera que vayas.</p>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100" src={reparacion} alt="Second slide"/>
                        <div className="carousel-caption d-none d-md-block">
                            <h5>Mantenimiento y soporte</h5>
                            <p>Ofrecemos nuestros talleres para tu servicio.</p>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100" src={mercedes} alt="Third slide"/>
                        <div className="carousel-caption d-none d-md-block">
                            <h5>Calidad y experiencia</h5>
                            <p>Más de 8 años de experiencia en el mercado.</p>
                        </div>
                    </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        </>
    )
}

export default Slider